export function createContextListenerKey(
  contextType: string | undefined,
  channel: string | undefined,
) {
  return `${contextType ?? '*'}${channel ? `|${channel}` : ''}`;
}
